var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallCenterIcoPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.05 6.34)",
    id: "TDW508ubOv2CO6Mc8IYIC"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-6.05, -6.34)",
    d: "M 2.3134 4.72262 C 2.36548 4.08838 2.56913 3.29137 3.02881 2.6152 C 3.57568 1.81082 4.49679 1.15505 6.05005 1.15505 C 7.60331 1.15505 8.52441 1.81082 9.07129 2.6152 C 9.53101 3.29137 9.73462 4.08838 9.78674 4.72262 L 9.55005 4.72262 C 8.90572 4.72262 8.38338 5.23084 8.38338 5.85775 L 8.38338 7.96586 C 8.38338 8.54164 8.82397 9.0173 9.39502 9.09106 C 9.34635 9.17667 9.29407 9.26102 9.23796 9.34354 C 8.86943 9.8856 8.33097 10.3601 7.54366 10.612 C 7.48722 10.1267 7.06392 9.74964 6.55005 9.74964 L 5.55005 9.74964 C 4.99776 9.74964 4.55005 10.1853 4.55005 10.7226 L 4.55005 11.3713 C 4.55005 11.9086 4.99776 12.3442 5.55005 12.3442 L 6.55005 12.3442 C 7.07288 12.3442 7.50199 11.9539 7.54626 11.4563 C 8.65251 11.1737 9.42322 10.5407 9.93298 9.79088 C 10.0845 9.56796 10.2124 9.33586 10.3195 9.101 L 10.8834 9.101 C 11.5277 9.101 12.05 8.59277 12.05 7.96586 L 12.05 5.85775 C 12.05 5.23084 11.5277 4.72262 10.8834 4.72262 L 10.6222 4.72262 C 10.5696 3.96733 10.3341 3.00305 9.76632 2.16787 C 9.07292 1.14792 7.89677 0.344238 6.05005 0.344238 C 4.20333 0.344238 3.02718 1.14792 2.33378 2.16787 C 1.76599 3.00305 1.53052 3.96733 1.47786 4.72262 L 1.21672 4.72262 C 0.572388 4.72262 0.0500488 5.23084 0.0500488 5.85775 L 0.0500488 7.96586 C 0.0500488 8.59277 0.572388 9.101 1.21672 9.101 L 2.55005 9.101 C 3.19438 9.101 3.71672 8.59277 3.71672 7.96586 L 3.71672 5.85775 C 3.71672 5.23084 3.19438 4.72262 2.55005 4.72262 L 2.3134 4.72262 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterIcoPurple);
export default __webpack_public_path__ + "static/media/call-center-ico_purple.cac2ac1781a6990410582a7e17cd6e00.svg";
export { ForwardRef as ReactComponent };